/**
 * Re-exported from @hyperframes/engine.
 * @see engine/src/utils/urlDownloader.ts for implementation.
 */
export {
  downloadToTemp,
  fetchPublicHttpsText,
  isHttpUrl,
  safeDownloadUrlIdentity,
  writeUrlDownloadTelemetry,
  type UrlDownloadTelemetry,
} from "@hyperframes/engine";
